import TrackingTimeline from "@/Shared/Tracking/CustomComponents/TrackingTimeline";
import type { TrackingLine } from "@/Shared/Tracking/Helpers/trackingGroupLinesIntoDates";
import type { ShipmentState } from "@freightsimple/generated-dashboard-openapi-client/models/ShipmentState";

import ShipmentSection from "@/Shared/Shipment/CustomComponents/ShipmentSection";

interface TrackingSectionProps {
  lines: Array<TrackingLine>;
  shipmentState: ShipmentState;
}
function ShipmentTrackingSection(props: TrackingSectionProps) {
  return (
    <ShipmentSection
      title="Detailed Tracking"
      subtitle="Tracking will automatically be updated as information is provided by the carrier"
      id="tracking-section"
    >
      <TrackingTimeline
        lines={props.lines}
        shipmentState={props.shipmentState}
      />
    </ShipmentSection>
  );
}
export default ShipmentTrackingSection;
